module.exports = __webpack_public_path__ + "img/grid_item-v2.ffd04497.svg";